// extracted by mini-css-extract-plugin
export default {"priceContainer":"ctotybrnq","oldPrice":"ca7ovpiv7","newPrice":"ccc48z2d5"};